import React, { useEffect } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { Spin } from "antd";
import {
  getAccountsIndividual,
  fetchIndividualVersions,
  getSubscribersVersions,
} from "../../store/slices/accountsTs";
import { checkIsLoaded, checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import { fetchAccountStatuses, fetchAccountTypes } from "../../store/slices/dicts";
import { useAppDispatch } from "../../index";
import { IindividualSearchValues } from "../../lib/interfaces/IindividualSearchValues";
import AccountListIndividual from "../../components/AccountListIndividual/AccountListIndividual";
import { AnyObject } from "../../lib/interfaces/AnyObject";
import { getAccountsVersions } from "../../store/slices/accounts";

interface IAccountsIndividualContainerTs {
  individualSearchValues: IindividualSearchValues;
  handleSetIndividualSearchValues: (prop: AnyObject) => void;
  individualSearchFullName: string;
  setIndividualSearchFullName: React.Dispatch<React.SetStateAction<string>>;
  initialIndividualSearchValues: IindividualSearchValues;
}

function AccountsIndividualContainerTs({
  routeProps,
}: {
  routeProps: IAccountsIndividualContainerTs;
}) {
  const {
    individualSearchValues,
    handleSetIndividualSearchValues,
    individualSearchFullName,
    setIndividualSearchFullName,
    initialIndividualSearchValues,
  } = routeProps;

  const dispatch = useAppDispatch();
  const { accountStatusesLoading, accountTypesLoading } = useSelector(
    (state: RootStateOrAny) => state.dicts
  );

  const handlePageableSearch = (props: IindividualSearchValues) => {
    dispatch(getAccountsIndividual(props));
  };

  useEffect(() => {
    handlePageableSearch(individualSearchValues);
  }, []);

  useEffect(() => {
    if (!checkIsLoaded(accountStatusesLoading)) dispatch(fetchAccountStatuses());
    if (!checkIsLoaded(accountTypesLoading)) dispatch(fetchAccountTypes());
  }, []);

  const getRowVersions = (params: {
    accountId: number;
    individualId: number;
    subscribersId: number[];
  }) => {
    const { accountId, individualId, subscribersId } = params;
    // @ts-ignore
    dispatch(getAccountsVersions({ accountsIds: [accountId] }));
    dispatch(fetchIndividualVersions({ individualId }));
    dispatch(getSubscribersVersions({ subscribersId }));
  };

  return (
    <div className="container_height">
      <Spin className="container_height" spinning={checkIsLoading(accountStatusesLoading)}>
        {checkIsLoaded(accountStatusesLoading, accountTypesLoading) && (
          <AccountListIndividual
            individualSearchValues={individualSearchValues}
            handleSetIndividualSearchValues={handleSetIndividualSearchValues}
            getRowVersions={getRowVersions}
            handlePageableSearch={handlePageableSearch}
            individualSearchFullName={individualSearchFullName}
            setIndividualSearchFullName={setIndividualSearchFullName}
            initialIndividualSearchValues={initialIndividualSearchValues}
          />
        )}
      </Spin>
    </div>
  );
}

export default AccountsIndividualContainerTs;
